// ** React Imports
import { useEffect } from "react";

// ** Next Imports
import { useNavigate } from "react-router-dom";

// ** Config
import authConfig from "src/configs/auth";

// ** React-Redux
import { useSelector } from "react-redux";

const GuestGuard = (props) => {
  const { children, fallback } = props;

  const { loading } = useSelector((state) => state.auth);

  console.log("loading", loading);

  const navigate = useNavigate();

  useEffect(() => {
    if (window.localStorage.getItem(authConfig.storageUserDataKeyName)) {
      navigate("/home");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return fallback;
  }

  return <>{children}</>;
};

export default GuestGuard;
